<div class="content">
  <div class="slider">
    <p class="organization">{{organization}}</p>
  </div>
</div>
